import React from 'react';
import Footer from '../../layout/footers/footer';
import Header from '../../layout/headers/header';
import Cta from '../common/cta/cta';
import BannerArea from '../common/banner-area';
import SobreArea from './sobre-area';
import Courses from '../common/curso/courses';
import EventArea from './event-area';
import HeroArea from './hero-area';
import Pricing from './pricing';
import TestimonialTwo from '../common/testimonials/testimonial-2';

const index = () => {
  return (
    <>
      {/* header start */}
      <Header />
      {/* header end */}

      {/* hero start */}
      <HeroArea />
      {/* hero end */}

      {/* banner start */}
      {/* <BannerArea /> */}
      {/* banner end */}

      {/* course start */}
      <Courses />
      {/* course end */}

      {/* sobre start */}
      <SobreArea />
      {/* sobre end */}

      {/* testimonial start */}
       <TestimonialTwo />
      {/* testimonial end */}

      {/* event start */}
      <EventArea />
      {/* event end */}

      {/* pricing start */}
      {/* <Pricing /> */}
      {/* pricing end */}

      {/* cta start */}
      <Cta />
      {/* cta end */}

      {/* footer start */}
      <Footer />
      {/* footer end */}
    </>
  );
};

export default index;